import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18N, GlobalContext } from 'commons';
import * as locationSelectors from 'state/selectors/locationSelectors';
import * as locationActions from 'state/actions/locationActions';
import { TablePaginationConfig, Table, Button, Space } from '@eb/antd'
import ExpectedLocationList from './expected-location/ExpectedLocationList';

const LocationSection = ({ getLocationList, locations, expLocExpose }) => {
  const {
    organization: { showAddress },
    account: { id: contactId },
  } = useContext(GlobalContext);

  useEffect(() => {
    getLocationList(contactId);
  }, []);

  return (
    <div className="location-section">
      {
      showAddress &&
      <div aria-labelledby="alertTitle">
        <div id="alertTitle" className="row subscription-title">
          <I18N>ssp.title.locations.static</I18N>
          </div>
          <div>
            <div className="location-info">
              {
              locations.map(location => (
              <div className="row">
                <span className="col-12 col-lg-5 text-lg-right label" id={location.locationName}>
                  {location.locationName}:
                  </span>
                  <span className="col-12 col-lg-7">
                    {location.streetAddress}
                    </span>
                    </div>
                    ))
                    }
          </div></div></div>
      }
      
      {
      expLocExpose &&
      <div aria-labelledby="alertTitle">
        <div id="alertTitle" className="row subscription-title">
          <I18N>ssp.title.locations.expected</I18N>
          </div>
          <ExpectedLocationList />
            </div>
      }

    </div>
  );
};

LocationSection.propTypes = {
  getLocationList: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  expLocExpose: PropTypes.bool,
};

LocationSection.defaultProps = {
  locations: [],
  expLocExpose: false,
};

const mapStateToProps = state => ({
  locations: locationSelectors.selectLocationAddresses(state),
  expLocExpose: locationSelectors.expLocExpose(state),
});

const mapDispatchToProps = dispatch => ({
  getLocationList: (contactId) => dispatch(locationActions.getLocationList.action({ contactId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationSection);
